import React, {useState, useEffect} from 'react';
import {Link, Navigate} from 'react-router-dom';
import './login.css';

import firebase from '../Config/firebase';
import {getAuth, signInWithEmailAndPassword} from 'firebase/auth';
import { collection, getFirestore, query, where, getDocs } from 'firebase/firestore';

function Login(){
    const [email,setEmail] = useState('');
    const [senha,setSenha] = useState('');
    const [cpf,setCpf] = useState('');
    const [sucesso,setSucesso] = useState('');
    const [mensagem,setMensagem] = useState('');
    const [p1,setP1] = useState('');
    const [tipo,setTipo] = useState('');
    const [succpf,setSuccpf] = useState('');
    const [setrota,setRota] = useState('');
    const [setcam,setCam] = useState('');
    const auth = getAuth();

    function CheckFili(){
    if (!cpf){
       setMensagem('Informe o CPF');
       return;
    }
    const fetchData = async () => {
        setSuccpf('N');
        const db = getFirestore();
        const q = query(collection(db, 'clientes'), where('cpf', '==', cpf));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
           // doc.data() is never undefined for query doc snapshots
           setP1(doc.id);
           setTipo(doc.data().tipo);
           setSuccpf('S');
           setMensagem('Cadastro Confirmado.');
           console.log("Documento ==> ", p1);
           console.log("Variavel cpf ==> ", succpf);
           if (doc.data().tipo === 'A') {setCam('A')} else {setCam('B')}
        });
        }
        fetchData();
        }

    function LoginUsuario(){
        setMensagem('');
        signInWithEmailAndPassword(auth,email,senha)
        .then(function(firebaseUser){ 
         CheckFili();     
         if (succpf === 'S') {
            if (tipo === 'A') {setCam('A')} else {setCam('B')}
            setRota('S')}   

         else {setRota('N')}
         setSucesso('S')
        })
        .catch(function(error){
         setSucesso('N')
        });
        }

    function alterarEmail(event){
        setEmail(event.target.value);
    }

    function alterarSenha(event){
        setSenha(event.target.value);
    }

    function alterarCpf(event){
        setCpf(event.target.value);
    }

    return <div className="tstcor1">
        <div className="mm2">
        <form>
          <img className="tstimg3" src="/images/logo8.png" alt="" />

          <h1 className="testeh5">Informe o e_mail e a senha da sua conta e seu CPF. O acesso é exclusivo para filiados</h1>

          <div className="form-floating">
              <input onChange={alterarEmail} type="email" className="form-control inptlg3" id="floatingInput" placeholder="E-mail" />
              <label className="flt2" htmlFor="floatingPassword">E-mail</label>
          </div>    
          <div className="form-floating">
              <input onChange={alterarSenha} type="password" className="form-control inptlg3" id="floatingPassword" placeholder="Senha" />
              <label className="flt2" htmlFor="floatingPassword">Senha</label>
          </div>
          <div className="form-floating">
              <input onChange={alterarCpf} type="text" className="form-control inptlg3" id="floatingInput" placeholder="CPF" maxLength={11}/>
              <label className="flt2" htmlFor="floatingPassword">CPF</label>
          </div>
  
          <button onClick={LoginUsuario} className="btn btn-primary py-2 butace3" type="button">Enviar</button>

            {mensagem.length>0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
            {sucesso==='N' ? <div className="alert alert-danger mt-2" role="alert">E-mail ou senha inválida</div> : null}
            {succpf==='N' ? <div className="alert alert-danger mt-2" role="alert">Cadastro não foi encontrado</div> : null}
            
            {setcam==='B' ? <Navigate to={'/app/mostrarprocesso/' + p1} /> : null} 
            {setcam==='A' ? <Navigate to='/app/home' /> : null}
            
            
            <div className="mt-4">
                <Link to="/app/resetsenha" className="mx-2 lnk5">Esqueci minha senha</Link>
                <Link to="/app/novaconta" className="mx-2 lnk6">Criar uma conta</Link> 
            </div>
            <p className="mt-3 mb-3 text-white-50 tstcopy2">&copy; Desenvolvido por Fernando Barros</p>
 
        </form>
        </div>
      </div>;
  }

  export default Login;